// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
}

.add-dividends-container {
  width: 100%;
  margin: 0;
}

.add-dividends-container .title {
  margin: 0 auto 10px;
}

.add-dividends-container form {
  background-color: #0e0f15;
  color: white;
  width: 100%;
  border: 2px solid #f09502;
  padding: 40px !important;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
}

.add-dividends-container form > div {
  width: 100%;
}

.add-dividends-container form label {
  margin-bottom: 3px;
  font-size: small;
  color: #ffffff !important; /* Color blanco para mejor contraste */
}

.add-dividends-container form .form-label {
  color: #ffffff !important;
  font-weight: 500;
}

.add-dividends-container form .form-check-label {
  color: #ffffff !important;
}

.errorInput {
  background-color: rgb(255, 196, 196);
}

.buttonMid {
  width: 10%;
  font-size: 20px;
}

.form-inline {
  display: flex;
  align-items: center;
}

.form-inline input {
  margin-right: 20px;
}

.containerImg {
  width: 40%;
}

.containerImg img {
  width: 100%;
  height: auto;
}

.custom-span {
  display: block;
  margin-bottom: 25px; /* Ajusta la separación entre los spans */
  margin-left: 25px;
  font-size: 1.5rem; /* Tamaño de fuente similar a h4 */
  color: orange; /* Color naranja */
  /* text-align: center; */
}


.marginDiv {
  margin-top: 35px;
}

.marginDiv p {
  margin: 0 25px 10px;
}

.marginDiv input {
  margin: 10px 0 25px 25px ;
}

/* Estilos para el dropdown de proyectos */
.form-select {
  background-color: #1a1b21;
  border: 1px solid #f09502;
  color: white;
}

.form-select:focus {
  background-color: #1a1b21;
  border-color: #f09502;
  box-shadow: 0 0 0 0.2rem rgba(240, 149, 2, 0.25);
  color: white;
}

.form-select option {
  background-color: #1a1b21;
  color: white;
}

.form-text.text-muted {
  color: #6c757d !important;
  font-size: 0.875em;
}

.d-flex.gap-2 {
  gap: 0.5rem;
}

/* Estilos para el botón de recarga */
.btn-outline-secondary {
  background-color: transparent;
  border-color: #f09502;
  color: #f09502;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.btn-outline-secondary:hover {
  background-color: #f09502;
  border-color: #f09502;
  color: white;
}

.btn-outline-secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.fa-spin {
  animation: fa-spin 2s infinite linear;
}

@keyframes fa-spin {
  0% {
      transform: rotate(0deg);
  }
  100% {
      transform: rotate(360deg);
  }
}

@media (max-width: 500px) {
  .add-dividends-container .title {
      margin: 15px auto 6px;
  }

  .add-dividends-container form {
      padding: 8px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/add-dividends/add-dividends/add-dividends.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,wBAAwB;EACxB,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB,EAAE,sCAAsC;AACnE;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB,EAAE,yCAAyC;EAC9D,iBAAiB;EACjB,iBAAiB,EAAE,kCAAkC;EACrD,aAAa,EAAE,kBAAkB;EACjC,wBAAwB;AAC1B;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA,qCAAqC;AACrC;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;MACI,uBAAuB;EAC3B;EACA;MACI,yBAAyB;EAC7B;AACF;;AAEA;EACE;MACI,qBAAqB;EACzB;;EAEA;MACI,uBAAuB;EAC3B;AACF","sourcesContent":[":host {\n  width: 100%;\n}\n\n.add-dividends-container {\n  width: 100%;\n  margin: 0;\n}\n\n.add-dividends-container .title {\n  margin: 0 auto 10px;\n}\n\n.add-dividends-container form {\n  background-color: #0e0f15;\n  color: white;\n  width: 100%;\n  border: 2px solid #f09502;\n  padding: 40px !important;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-wrap: wrap;\n}\n\n.add-dividends-container form > div {\n  width: 100%;\n}\n\n.add-dividends-container form label {\n  margin-bottom: 3px;\n  font-size: small;\n  color: #ffffff !important; /* Color blanco para mejor contraste */\n}\n\n.add-dividends-container form .form-label {\n  color: #ffffff !important;\n  font-weight: 500;\n}\n\n.add-dividends-container form .form-check-label {\n  color: #ffffff !important;\n}\n\n.errorInput {\n  background-color: rgb(255, 196, 196);\n}\n\n.buttonMid {\n  width: 10%;\n  font-size: 20px;\n}\n\n.form-inline {\n  display: flex;\n  align-items: center;\n}\n\n.form-inline input {\n  margin-right: 20px;\n}\n\n.containerImg {\n  width: 40%;\n}\n\n.containerImg img {\n  width: 100%;\n  height: auto;\n}\n\n.custom-span {\n  display: block;\n  margin-bottom: 25px; /* Ajusta la separación entre los spans */\n  margin-left: 25px;\n  font-size: 1.5rem; /* Tamaño de fuente similar a h4 */\n  color: orange; /* Color naranja */\n  /* text-align: center; */\n}\n\n\n.marginDiv {\n  margin-top: 35px;\n}\n\n.marginDiv p {\n  margin: 0 25px 10px;\n}\n\n.marginDiv input {\n  margin: 10px 0 25px 25px ;\n}\n\n/* Estilos para el dropdown de proyectos */\n.form-select {\n  background-color: #1a1b21;\n  border: 1px solid #f09502;\n  color: white;\n}\n\n.form-select:focus {\n  background-color: #1a1b21;\n  border-color: #f09502;\n  box-shadow: 0 0 0 0.2rem rgba(240, 149, 2, 0.25);\n  color: white;\n}\n\n.form-select option {\n  background-color: #1a1b21;\n  color: white;\n}\n\n.form-text.text-muted {\n  color: #6c757d !important;\n  font-size: 0.875em;\n}\n\n.d-flex.gap-2 {\n  gap: 0.5rem;\n}\n\n/* Estilos para el botón de recarga */\n.btn-outline-secondary {\n  background-color: transparent;\n  border-color: #f09502;\n  color: #f09502;\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n}\n\n.btn-outline-secondary:hover {\n  background-color: #f09502;\n  border-color: #f09502;\n  color: white;\n}\n\n.btn-outline-secondary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.fa-spin {\n  animation: fa-spin 2s infinite linear;\n}\n\n@keyframes fa-spin {\n  0% {\n      transform: rotate(0deg);\n  }\n  100% {\n      transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 500px) {\n  .add-dividends-container .title {\n      margin: 15px auto 6px;\n  }\n\n  .add-dividends-container form {\n      padding: 8px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
